import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { HowItWorks } from '../components/HowItWorks';
import { PrivacySection } from '../components/PrivacySection';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  useScreenInit();
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-195" data-mp="24gijs9n674m8">
      <Navbar data-id="element-196" data-mp="24ivcnhuguze2" />
      <main className="flex-1" data-id="element-197" data-mp="29g4zcpqh0wy7">
        <Hero data-id="element-198" data-mp="29f28uix28wit" />
        <Features data-id="element-199" data-mp="29fbww0yjotlv" />
        <HowItWorks data-id="element-200" data-mp="29etxivgl5z9q" />
        <PrivacySection data-id="element-201" data-mp="2dhqi2rpos5gb" />
        <FAQ data-id="element-202" data-mp="2di8eboccmjo8" />
        <FinalCTA data-id="element-203" data-mp="2dirsqv2sipxi" />
      </main>
      <Footer data-id="element-204" data-mp="2dj1j4jrqyz3q" />
    </div>;
}